import React from 'react';
import './SiteFooter.css';

const SiteFooter: React.FC = () => (
  <footer className="site-footer">
    <div className="site-footer-content">
      <p>
        <strong>Fantasy Archive</strong> is an unofficial, non-commercial fan archive created for
        members and friends of the Gibsons League.
      </p>
      <p>
        This site is not affiliated with, endorsed by, or sponsored by the NFL, NFLPA, any NFL
        club, Yahoo, or their affiliates. Team names and trademarks belong to their respective
        owners. Player names and league statistics are used for historical and informational
        purposes. Player photographs and other third-party media remain the property of their
        respective rights holders.
      </p>
    </div>
  </footer>
);

export default SiteFooter;
